<slider side="left">

    <div body>
        <pages-menu class="top-menu lvl-0"></pages-menu>
        <div class="btn-menu">
            <div>
                <a href="tel:+79161643929">+7 (916) 164-39-29 </a>
            </div>
            <div>
                <a href="mailto:info@rrms.ru">info@rrms.ru</a>
            </div>
            <div class="icons">
                <a href="#">
                <img class="youtube" src="assets/images/youtube_logo.svg" alt="">
                </a>
                <a href="#">
                <img class="telegram" src="assets/images/telegram_logo.svg" alt="">
                </a>
            </div>
        </div>
    </div>        
</slider>